/* unplugin-vue-components disabled */import { render } from "./SpeachPollsResults.vue?vue&type=template&id=4d749199&scoped=true&ts=true"
import script from "./SpeachPollsResults.vue?vue&type=script&lang=ts"
export * from "./SpeachPollsResults.vue?vue&type=script&lang=ts"

import "./SpeachPollsResults.vue?vue&type=style&index=0&id=4d749199&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d749199"]])

export default __exports__